import Cookies from 'js-cookie';

const ellipsis = (text, size) => {
    return `${text.split(' ').slice(0, size).join(' ')}...`;
};

export { ellipsis };


export const DEBUG      = true;

export const handleLogout = () => {
    Cookies.remove('SangLoggedIn');
    Cookies.remove('SangLoggedData');
    window.location.href = '/login';
};
